import { useEffect } from 'react';
import { Subject } from 'rxjs';

/*
 * event type in order to (listen to) or (fire) // Here we can use any type for
 * payload eslint-disable-next-line @typescript-eslint/no-explicit-any
 */
export type EventbusEvent<T = any> = {
  /*
   * naming convention for key is: [scope].[action] ex.
   * StepViewerEvents.InitiateNextViewRender
   */
  key: string;
  id?: string | Symbol;
  payload?: T;
};

type UseEventbusProps = {
  onEvent: (event: EventbusEvent) => void;
};

// eventloop Subject Observable
export const eventbusSubject = new Subject<EventbusEvent>();

export const fireEvent = (event: EventbusEvent) => {
  eventbusSubject.next(event);
};

/**
 * Hook allows fire and list events between components
 * @param props - onEvent callback to fire on Subject Observable subscribed
 * event
 * @param deps - dependencies for onEvent
 * @returns Function (fireEvent callback)
 */
// Here we can use any type for dependencies
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useEventbus = (props?: UseEventbusProps, deps: any[] = []) => {
  const { onEvent } = props || {};

  useEffect(() => {
    // skip useEffect if onEvent is empty
    if (!onEvent) {
      return;
    }

    // subscribe to the Subject Observable
    const subscription = eventbusSubject.subscribe(onEvent);

    /*
     * we should unsubscribe after component's unmount to remove extra
     * subscribes
     */
    return () => {
      subscription.unsubscribe();
    };
  }, deps);

  return {
    /*
     * on fireEvent, we should push the event into the eventbus subject's
     * observer
     */
    fireEvent
  };
};
